import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import initBootstrapComponents from '../../utils/bootstrap';
import '@splidejs/react-splide/css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

const CustomerLogin = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    useEffect(() => {
        // Initialize Bootstrap components when component mounts
        initBootstrapComponents();
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        // TODO: Implement login logic
        navigate('/customer-bookings');
    };

    return (
        <div className="d-flex flex-column justify-content-between min-vh-100" id="body-container">
            <Header />

            <main>
                <section className="py-32 pt-lg-124 pb-lg-332">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-7 col-xl-6">
                                <div className="bg-motability-mid-black-5 border border-motability-mid-black-2 p-4 p-32 rounded-4">
                                    <h1 className="h3 text-primary mb-4 mb-lg-32">
                                        Sign in to manage your bookings
                                    </h1>

                                    <form onSubmit={handleSubmit} className="custom" id="manage-bookings-login-form">
                                        <fieldset>
                                            <div className="row justify-content-between align-items-center gap-3">
                                                <div className="form-group">
                                                    <label htmlFor="manage-bookings-login-email-address" className="small ms-1 mb-1">
                                                        Email address
                                                    </label>

                                                    <input 
                                                        name="email-address" 
                                                        id="manage-bookings-login-email-address" 
                                                        type="email" 
                                                        className="form-control f-input-lg border-motability-mid-black-40 shadow-motability-mid-black-12-inset" 
                                                        placeholder="e.g. johnsmith@mail.com" 
                                                        required
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                    />
                                                </div>

                                                <div>
                                                    <button type="submit" className="btn btn-primary mt-2 mt-lg-3 px-29">
                                                        Sign in
                                                    </button>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default CustomerLogin;
